<template>
  <div class="ept-author-content">
    <h2>Publicações</h2>

    <div class="w-full py-5 md:w-1/2">
      <select-single v-model="form.order" :options="orderOptions" placeholder="Ordenar por" />
    </div>

    <loading-container ref="container" :loading="loading" loading-container-class="h-64">
      <div v-if="collection.length === 0" class="h-56 w-full flex flex-col">
        <h2 class="text-2xl ">Nenhum resultado encontrado.</h2>
        <p>Tente pesquisar novamente utilizando critérios diferentes.</p>
      </div>
      <div v-else key="content" class="w-full flex flex-col">
        <content-card v-for="item in collection" :key="item.slug" :content="item" />
      </div>
    </loading-container>

    <pagination-with-number v-if="!loading && totalRows > 0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="mb-20" />
  </div>
</template>

<script>
import ContentCard from './ContentCard'
import LoadingContainer from 'components/shared/LoadingContainer'
import PaginationWithNumber from 'components/shared/PaginationWithNumber'
import SelectSingle from 'components/form/SelectSingle'
import {
  data as collectionData,
  watch as collectionWatch,
  methods as collectionMethod
} from 'helpers/resource/list'

export default {
  components: {
    ContentCard,
    LoadingContainer,
    PaginationWithNumber,
    SelectSingle
  },

  props: {
    authorId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    ...collectionData,
    form: {
      order: null
    },
  }),

  computed: {
    orderOptions() {
      return [
        { name: 'Mais recente', id: null },
        { name: 'Mais antigo', id: 'most_older' },
        { name: 'Ordem alfabética', id: 'alphabetical_order' }
      ]
    },

    queryParams () {
      const form = this.form
      return {
        ...form,
        author_id: this.authorId,
        page: this.currentPage,
        per_page: this.perPage
      }
    },

    url() {
      return '/api/v1/contents'
    }
  },

  watch: {
    ...collectionWatch,

    form: {
      deep: true,

      handler() {
        this.onFilterChanges()
      }
    }
  },

  created() {
    this.fetchCollection()
  },

  methods: {
    ...collectionMethod
  }
}
</script>

<style lang="scss" scoped>
.ept-author-content {
  @apply w-full;

  h2 {
    font-size: 1.75rem;
    line-height: 1;
  }
}
</style>
